import { toast } from "react-toastify";

export const showToast = {
  success: (message: string) => {
    toast.dismiss();
    toast.success(message);
  },

  error: (message: string) => {
    toast.dismiss();
    toast.error(message);
  },

  info: (message: string) => {
    toast.dismiss();
    toast.info(message);
  },

  warning: (message: string) => {
    toast.dismiss();
    toast.warn(message);
  },
};
